import { Line } from "vue-chartjs"
    
export default {
    extends: Line,
    props: ['data', 'options'],
    computed: {
        formatedData () {
            return {
                labels: this.getLabels(),
                datasets: [
                    {
                        label: 'On Hand',
                        lineColor: '#0000ff',
                        data: this.getDatas('on_hand'),
                        fill: false,
                        borderColor: 'rgb(75, 192, 192)',
                        pointRadius:0,
                        tension: 0.1
                    },
                    {
                        label: 'Pending',
                        backgroundColor: '',
                        data: this.getDatas('pending'),
                        fill: false,
                        borderColor: 'rgb(255, 103, 92)',
                        pointRadius:0,
                        tension: 0.1
                    },
                    {
                        label: 'Incoming',
                        backgroundColor: '',
                        data: this.getDatas('incoming'),
                        fill: false,
                        borderColor: 'rgb(190, 255, 92)',
                        pointRadius:0,
                        tension: 0.1
                    }
                ]
            }
        }
    },
    watch: {
        data () {
            this.renderChart(this.formatedData)
        }
    },
    mounted () {
      // Overwriting base render method with actual data.
      this.renderChart(this.formatedData)
    },
    methods: {
        getLabels () {
            return this.data.map(d => {
                return new Date(d.created_at).toLocaleDateString()
            })
        },
        getDatas (type) {
            return this.data.map(d => d[type])
        }
    }
}